export default "/fonts/vendor/element-plus/dist/element-icons.ttf?5bba4d970ff1530bc4225a59346fe298";